export const ACTIVE = {
  name: 'Active',
  value: 'ACTIVE',
  sequence: 1,
};

export const INACTIVE = {
  name: 'Inactive',
  value: 'INACTIVE',
  sequence: 2,
};

export const DELETED = {
  name: 'Deleted',
  value: 'DELETED',
  sequence: 3,
};

export const CREATION_IN_PROGRESS = {
  name: 'Creation in Progress',
  value: 'CREATION_IN_PROGRESS',
  status: 'INACTIVE',
  sequence: 4,
};

export const DEPLOY_FAILED = {
  name: 'Deploy Failed',
  value: 'DEPLOY_FAILED',
  status: 'INACTIVE',
  sequence: 5,
};

export const REMOVING = {
  name: 'Removing',
  value: 'REMOVING',
  status: 'INACTIVE',
  sequence: 6,
};

const Basic = [
  ACTIVE,
  INACTIVE,
  DELETED,
  CREATION_IN_PROGRESS,
  DEPLOY_FAILED,
  REMOVING,
];

const BasicSelector = [
  ACTIVE,
  INACTIVE,
  DELETED,
  CREATION_IN_PROGRESS,
  DEPLOY_FAILED,
];

const BasicField = [ACTIVE, INACTIVE, DELETED];

const BasicByValue = Basic.reduce((hash, status) => {
  hash[status.value] = status;
  return hash;
}, {});

const BasicValues = Object.keys(BasicByValue);

export default {
  Basic,
  BasicSelector,
  BasicField,
  BasicByValue,
  BasicValues,

  ACTIVE,
  DELETED,
  INACTIVE,
  CREATION_IN_PROGRESS,
  DEPLOY_FAILED,
  REMOVING,
};
